import { render } from "./PimLabProductsOverviewTilesItem.vue?vue&type=template&id=4024f445&scoped=true&ts=true"
import script from "./PimLabProductsOverviewTilesItem.vue?vue&type=script&lang=ts"
export * from "./PimLabProductsOverviewTilesItem.vue?vue&type=script&lang=ts"

import "./PimLabProductsOverviewTilesItem.vue?vue&type=style&index=0&id=4024f445&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/bouwstenen/Bouwsteen_BuildAndDeploy_Vue_Frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4024f445"]])

export default __exports__